const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Contacto inicial',
      description: 'Llámanos o escríbenos por WhatsApp. Te atendemos en menos de 2 horas para entender tus necesidades.',
      icon: 'ri-phone-line',
    },
    {
      number: '02',
      title: 'Presupuesto gratuito',
      description: 'Visitamos el inmueble y te ofrecemos un presupuesto detallado sin compromiso en 24 horas.',
      icon: 'ri-file-list-3-line',
    },
    {
      number: '03',
      title: 'Ejecución del servicio',
      description: 'Nuestro equipo profesional realiza el vaciado y limpieza con total discreción y eficiencia.',
      icon: 'ri-team-line',
    },
    {
      number: '04',
      title: 'Entrega final',
      description: 'Dejamos el espacio completamente limpio y listo para entregar. Garantía de satisfacción.',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Cómo trabajamos en 4 pasos simples
          </h2>
          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Proceso transparente y profesional para el <strong>vaciado de pisos en El Prat de Llobregat</strong>
          </p>
        </div>

        {/* Desktop Timeline */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Connection Line */}
            <div className="absolute top-16 left-0 right-0 h-0.5 bg-primary/30"></div>
            <div className="absolute top-16 left-0 h-0.5 bg-primary transition-all duration-1000 w-full"></div>

            {/* Steps */}
            <div className="grid grid-cols-4 gap-8 relative">
              {steps.map((step, index) => (
                <div key={index} className="text-center">
                  {/* Circle */}
                  <div className="relative inline-flex items-center justify-center w-32 h-32 bg-white border-4 border-primary rounded-full mb-6 shadow-lg">
                    <span className="text-4xl font-bold text-primary">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-3xl text-primary`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-dark mb-3">{step.title}</h3>
                  <p className="text-dark/70 leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile Timeline */}
        <div className="lg:hidden space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="flex gap-6">
              {/* Left Side - Number Circle */}
              <div className="flex-shrink-0">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>
                {index < steps.length - 1 && (
                  <div className="w-0.5 h-16 bg-primary/30 mx-auto mt-4"></div>
                )}
              </div>

              {/* Right Side - Content */}
              <div className="flex-1 pt-2">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3">
                  <i className={`${step.icon} text-2xl text-primary`}></i>
                </div>
                <h3 className="text-xl font-bold text-dark mb-2">{step.title}</h3>
                <p className="text-dark/70 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
